import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const rootElement = document.querySelector("#root");
ReactDOM.createRoot(rootElement).render(<App />);
